import React from 'react';
import PropTypes from 'prop-types';
import style from './style.module.scss';

/*
 * MainTitle
 *  - Component that display the H1 title of Design Section
 */
export function MainTitle({title}) {
  return <h1 className={style.designView_left_title}>{title}</h1>;
}

MainTitle.propTypes = {
  /*
   * Main title for the design section
   */
  title: PropTypes.string.isRequired,
};

MainTitle.defaultProps = {
  title: '',
};
